import { type JobylonEmbedFilters } from "@/app/(site)/_components/SanityBlocks/JobylonBlock/buildJobylonFilters"

export type JobylonEmbedConfig = {
    companyId: number
    pageSize: number
    filters?: JobylonEmbedFilters
}

export const JOBYLON_WIDGET_ID_PREFIX = "jobylon-jobs-widget"

export function getJobylonWidgetTargetId(blockKey?: string) {
    return blockKey ? `${JOBYLON_WIDGET_ID_PREFIX}-${blockKey}` : JOBYLON_WIDGET_ID_PREFIX
}
